"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.texMathit = {
    0x20: [0, 0, .25],
    0x21: [.716, 0, .307, { ic: .073 }],
    0x22: [.694, -0.379, .514, { ic: .024 }],
    0x23: [.694, .194, .818, { ic: .01 }],
    0x25: [.75, .056, .818, { ic: .029 }],
    0x26: [.716, .022, .767, { ic: .035 }],
    0x27: [.694, -0.379, .307, { ic: .07 }],
    0x28: [.75, .25, .409, { ic: .108 }],
    0x29: [.75, .25, .409],
    0x2A: [.75, -0.32, .511, { ic: .073 }],
    0x2B: [.557, .057, .767],
    0x2C: [.121, .194, .307],
    0x2D: [.251, -0.18, .358],
    0x2E: [.121, 0, .307],
    0x2F: [.75, .25, .511, { ic: .106 }],
    0x30: [.665, .021, .511, { ic: .051 }],
    0x31: [.666, 0, .511],
    0x32: [.666, .022, .511, { ic: .04 }],
    0x33: [.666, .022, .511, { ic: .051 }],
    0x34: [.666, .194, .511],
    0x35: [.666, .022, .511, { ic: .056 }],
    0x36: [.665, .022, .511, { ic: .054 }],
    0x37: [.666, .022, .511, { ic: .123 }],
    0x38: [.666, .021, .511, { ic: .042 }],
    0x39: [.666, .022, .511, { ic: .042 }],
    0x3A: [.431, 0, .307],
    0x3B: [.431, .194, .307],
    0x3D: [.367, -0.133, .767],
    0x3F: [.716, 0, .511, { ic: .04 }],
    0x40: [.705, .011, .767, { ic: .022 }],
    0x41: [.716, 0, .743],
    0x42: [.683, 0, .704, { ic: .028 }],
    0x43: [.705, .021, .716, { ic: .096 }],
    0x44: [.683, 0, .755, { ic: .02 }],
    0x45: [.68, 0, .678, { ic: .065 }],
    0x46: [.68, 0, .653, { ic: .078 }],
    0x47: [.705, .022, .774, { ic: .038 }],
    0x48: [.683, 0, .743, { ic: .117 }],
    0x49: [.683, 0, .386, { ic: .122 }],
    0x4A: [.683, .021, .525, { ic: .097 }],
    0x4B: [.683, 0, .769, { ic: .09 }],
    0x4C: [.683, 0, .627],
    0x4D: [.683, 0, .897, { ic: .113 }],
    0x4E: [.683, 0, .743, { ic: .117 }],
    0x4F: [.704, .022, .767, { ic: .021 }],
    0x50: [.683, 0, .678, { ic: .051 }],
    0x51: [.704, .194, .767, { ic: .021 }],
    0x52: [.683, .022, .729],
    0x53: [.705, .022, .562, { ic: .071 }],
    0x54: [.677, 0, .716, { ic: .09 }],
    0x55: [.683, .022, .743, { ic: .117 }],
    0x56: [.683, .022, .743, { ic: .125 }],
    0x57: [.683, .022, .999, { ic: .125 }],
    0x58: [.683, 0, .743, { ic: .082 }],
    0x59: [.683, 0, .743, { ic: .132 }],
    0x5A: [.683, 0, .613, { ic: .091 }],
    0x5B: [.75, .25, .307, { ic: .139 }],
    0x5D: [.75, .25, .307, { ic: .052 }],
    0x5E: [.694, -0.527, .511, { ic: .017 }],
    0x5F: [-0.025, .062, .511, { ic: .043 }],
    0x61: [.442, .011, .511, { ic: .032 }],
    0x62: [.694, .011, .46],
    0x63: [.441, .01, .46],
    0x64: [.694, .011, .511, { ic: .056 }],
    0x65: [.442, .01, .46, { ic: .01 }],
    0x66: [.705, .204, .307, { ic: .143 }],
    0x67: [.442, .205, .46, { ic: .034 }],
    0x68: [.694, .011, .511, { ic: .033 }],
    0x69: [.656, .01, .307, { ic: .033 }],
    0x6A: [.656, .204, .307, { ic: .057 }],
    0x6B: [.694, .011, .46, { ic: .038 }],
    0x6C: [.694, .011, .256, { ic: .056 }],
    0x6D: [.442, .011, .818, { ic: .033 }],
    0x6E: [.442, .011, .562, { ic: .033 }],
    0x6F: [.442, .011, .511],
    0x70: [.442, .194, .511],
    0x71: [.442, .194, .46, { ic: .044 }],
    0x72: [.442, .011, .422, { ic: .062 }],
    0x73: [.442, .011, .409],
    0x74: [.626, .011, .332, { ic: .041 }],
    0x75: [.441, .011, .537, { ic: .033 }],
    0x76: [.443, .01, .46, { ic: .032 }],
    0x77: [.443, .011, .664, { ic: .032 }],
    0x78: [.442, .011, .464, { ic: .049 }],
    0x79: [.441, .205, .486, { ic: .036 }],
    0x7A: [.442, .011, .409, { ic: .057 }],
    0x7E: [.318, -0.208, .511, { ic: .06 }],
    0xA0: [0, 0, .25],
    0xA3: [.714, .011, .769],
    0x131: [.441, .01, .307, { ic: .033 }],
    0x237: [.442, .204, .332],
    0x300: [.697, -0.5, 0],
    0x301: [.697, -0.5, 0, { ic: .039 }],
    0x302: [.694, -0.527, 0, { ic: .017 }],
    0x303: [.668, -0.558, 0, { ic: .06 }],
    0x304: [.589, -0.544, 0, { ic: .054 }],
    0x306: [.694, -0.515, 0, { ic: .062 }],
    0x307: [.669, -0.548, 0],
    0x308: [.669, -0.554, 0, { ic: .045 }],
    0x30A: [.716, -0.542, 0],
    0x30B: [.697, -0.503, 0, { ic: .065 }],
    0x30C: [.638, -0.502, 0, { ic: .029 }],
    0x391: [.716, 0, .743],
    0x392: [.683, 0, .704, { ic: .028 }],
    0x393: [.68, 0, .627, { ic: .078 }],
    0x394: [.716, 0, .818],
    0x395: [.68, 0, .678, { ic: .065 }],
    0x396: [.683, 0, .613, { ic: .091 }],
    0x397: [.683, 0, .743, { ic: .117 }],
    0x398: [.704, .022, .767, { ic: .021 }],
    0x399: [.683, 0, .386, { ic: .122 }],
    0x39A: [.683, 0, .769, { ic: .09 }],
    0x39B: [.716, 0, .692],
    0x39C: [.683, 0, .897, { ic: .113 }],
    0x39D: [.683, 0, .743, { ic: .117 }],
    0x39E: [.677, 0, .664, { ic: .09 }],
    0x39F: [.704, .022, .767, { ic: .021 }],
    0x3A0: [.68, 0, .743, { ic: .116 }],
    0x3A1: [.683, 0, .678, { ic: .051 }],
    0x3A2: [.704, .022, .767, { ic: .021 }],
    0x3A3: [.683, 0, .716, { ic: .066 }],
    0x3A4: [.677, 0, .716, { ic: .09 }],
    0x3A5: [.705, 0, .767, { ic: .065 }],
    0x3A6: [.683, 0, .716, { ic: .012 }],
    0x3A7: [.683, 0, .743, { ic: .082 }],
    0x3A8: [.683, 0, .767, { ic: .057 }],
    0x3A9: [.705, 0, .716, { ic: .043 }],
    0x3D2: [.705, 0, .767, { ic: .065 }],
    0x3DC: [.68, 0, .653, { ic: .078 }],
    0x2013: [.285, -0.248, .511, { ic: .043 }],
    0x2014: [.285, -0.248, 1.022, { ic: .016 }],
    0x2015: [.285, -0.248, 1.022, { ic: .016 }],
    0x2017: [-0.025, .062, .511, { ic: .043 }],
    0x2018: [.694, -0.379, .307, { ic: .055 }],
    0x2019: [.694, -0.379, .307, { ic: .07 }],
    0x201C: [.694, -0.379, .514, { ic: .092 }],
    0x201D: [.694, -0.379, .514, { ic: .024 }],
    0x2044: [.75, .25, .511, { ic: .106 }],
    0x210F: [.695, .013, .54, { ic: .022 }],
    0x2206: [.716, 0, .818],
};
//# sourceMappingURL=tex-mathit.js.map